<template>
  <base-list-overview
    controller="Child"
    :filter="Filter"
    hide-actions
    link-controller="Child/CarePartner"
    :link-key="link.key"
    link-table
    redirect
    redirect-page="Children"
    :rights="Rights"
    tab="children"
    type="child"
    :visible="visible"
  />
</template>

<script>
import BaseListOverview from '@/components/shared/base/base-list-overview'
import ContentMixin from '@/mixins/content-mixin'

export default {
  name: 'CarePartnersChildren',
  components: {
    BaseListOverview
  },
  mixins: [
    ContentMixin
  ],
  data () {
    return {
      link: {
        key: 'idCarePartner'
      }
    }
  },
  computed: {
    Filter () {
      return [
        {
          key: this.link.key,
          value: this.ContentMixin_Element[this.link.key]
        }
      ]
    },
    Rights () {
      return this.AuthenticationMixin_UserIsAdministrator() ? {
        allowCreate: true,
        allowDelete: true,
        allowRead: true,
        allowUpdate: true
      } : null
    }
  }
}
</script>
